import React from "react";
import "./spinner.less";

interface SpinnerInterface { 
   size?: "small" | "default" | "large";
   className?: string,
   id?: string,
   key?: string | number,
   style?: React.CSSProperties
}

export const Spin : React.FC<SpinnerInterface> =({
    size = 'default',
    className='',
    id,
    key,
    style
}) => {
    const dots : React.ReactElement[] = []  

    for(let i : number = 0; i < 4; i++) {
        dots.push(
            <i className={'spin-dot-item ' + size.toLocaleLowerCase()}
                key={i}
            ></i>
        )
    }
    
    return (
        <div 
            className={'bp2-spinner-component ' + (className)}
            id={id}
            key={key}
            style={style}
        >
            <span className={'spin-dots ' + size.toLocaleLowerCase()}>
                {dots.map((item) => item)}
            </span>
        </div>
    );
};

export default Spin;